import { render, staticRenderFns } from "./set-other.vue?vue&type=template&id=52a82707&scoped=true"
import script from "./set-other.vue?vue&type=script&lang=ts"
export * from "./set-other.vue?vue&type=script&lang=ts"
import style0 from "./set-other.vue?vue&type=style&index=0&id=52a82707&prod&lang=scss"
import style1 from "./set-other.vue?vue&type=style&index=1&id=52a82707&prod&lang=scss&scoped=true"
import style2 from "./set-other.vue?vue&type=style&index=2&id=52a82707&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a82707",
  null
  
)

export default component.exports